// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3qvid","bigColWidth":"Table_bigColWidth__LzOrV","biggerColWidth":"Table_biggerColWidth__3MmMb","row":"Table_row__3z_9c","col":"Table_col__2N2pC"};